import { Navigate } from "react-router-dom";
import { Account } from "@pages/Account";
import { ConnectedAppsPage } from "@pages/ConnectedAppsPage";
import { SettingsPage } from "@pages/SettingsPage";
import { AppConnectionMessage } from "@pages/AppConnectionMessage";
import { SettingsProfile } from "@pages/SettingsProfile";
import { ManageSubscriptionPage } from "@pages/ManageSubscriptionPage";
import { LearningCenterPage } from "@pages/LearningCenterPage";
import { AppRoute } from "./types";
import { generateRoute } from "./generate-route";

const dashboardRouteConfig = {
  dashboard: {
    route: generateRoute("/account"),
    element: <Account />,
    protected: true,
  },
  integrations: {
    route: generateRoute("/account/integrations"),
    element: <ConnectedAppsPage />,
    protected: true,
  },
  connectedApps: {
    // Keeping for backward compatibility
    route: generateRoute("/account/connected-apps"),
    element: <Navigate to="/account/integrations" replace />,
    protected: true,
  },
  accountSettings: {
    route: generateRoute("/account/settings"),
    element: <SettingsPage />,
    protected: true,
  },
  profile: {
    route: generateRoute("/account/profile"),
    element: <SettingsProfile />,
    protected: true,
  },
  subscription: {
    route: generateRoute("/account/subscription"),
    element: <ManageSubscriptionPage />,
    protected: true,
  },
  learningCenter: {
    route: generateRoute("/help/learning-center"),
    element: <LearningCenterPage />,
    protected: true,
  },
  appConnection: {
    route: generateRoute<{ appId: string }>(
      "/account/app-connection/:appId/success",
    ),
    element: <AppConnectionMessage />,
  },

  // Redirects
  settingsRedirect: {
    route: generateRoute("/settings"),
    element: <Navigate to="/account" replace />,
  },
  dashboardRedirect: {
    // Keeping for backward compatibility with old bookmarks/links.
    route: generateRoute("/dashboard"),
    element: <Navigate to="/account" replace />,
  },
} as const;

export const dashboardRoutes: AppRoute[] = Object.values(
  dashboardRouteConfig,
).map(({ route, element, ...rest }) => ({
  path: route.originalPath,
  element,
  ...rest,
}));

export const dashboardRoutePaths = Object.fromEntries(
  Object.entries(dashboardRouteConfig).map(([key, { route }]) => [key, route]),
) as {
  [K in keyof typeof dashboardRouteConfig]: (typeof dashboardRouteConfig)[K]["route"];
};
